import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, ApiVersion } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';
import { AlunosModel } from '../alunos/alunos.model';

@Injectable()
export class AlunoService {
  constructor(private http: HttpClient, private apiService: ApiService) { }

  loading = true;

  hide() {
    this.loading = false;
  }

  getFormularios(id: string) {
    return this.http.get<any[]>(
      `${this.apiService.getUrl()}/${ApiVersion}/alunos/${id}/formularios`
    );
  }

  getAlunosDeTodasAsTurmas(
    hashPeriodo: string,
    hashEscola: string,
    hashSerie: string
  ): Observable<AlunosModel[]> {
    return this.http.get<AlunosModel[]>(
      `${this.apiService.getUrl()}/${ApiVersion}/alunos?hashPeriodo=${hashPeriodo}&hashEscola=${hashEscola}&hashSerie=${hashSerie}`
    );
  }

  getAlunoPorTurma(hashTurma: string): Observable<AlunosModel[]> {
    return this.http.get<AlunosModel[]>(
      `${this.apiService.getUrl()}/${ApiVersion}/alunosturma/${hashTurma}/alunos`
    );
  }

  getImg(hashFoto, qualidade: 'baixa' | 'media'): string {
    if (hashFoto) {
      let url:string=`${environment.paths.portal}/content/fotos/${hashFoto}`;

      const blob: Blob = new Blob([url]);
      let urlCreator = window.URL;
      return urlCreator.createObjectURL(blob);

    }
    return null;
  }

  validarTokenAluno(token: string): Observable<AlunosModel> {
    return this.http.get<AlunosModel>(
      `${this.apiService.getUrl()}/${ApiVersion}/auth/${token}/aluno`
    );
  }
}
